import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  ActionsGroup,
  Checkbox,
  DialogActions,
  DialogContent,
  FlatButton,
  NumberInput,
  RaisedButton,
  useToggle,
} from "@evergis/ui";

import { ModalDialog } from "../../../Dialogs/DialogComponents/ModalDialog";
import { DialogForm, DialogRow } from "./styled";
import { Dash } from "../../../Dialogs/Classification/styled";
import { SYMBOL_LIMITS } from "../../limits";
import { useDialogReset } from "../../../../hooks/useDialogs";
import { useClusterSizeRanges } from "./hooks/useClusterSizeRanges";
import { Units } from "../../../Classification/types";

export const SIZE_RANGES_DEFAULTS = {
  maxWidth: "23.5rem",
};

export const ClusterSizeRanges: FC = () => {
  const { t } = useTranslation();
  const resetDialog = useDialogReset();
  const [checked, toggleChecked] = useToggle();
  const { changeFrom, from, changeTo, to, getSingleObjectSize, recalc } = useClusterSizeRanges();

  const toggleSingleObjectSize = useCallback(() => {
    toggleChecked();
    getSingleObjectSize();
  }, [getSingleObjectSize, toggleChecked]);

  return (
    <ModalDialog maxWidth={SIZE_RANGES_DEFAULTS.maxWidth}>
      <DialogContent>
        <DialogForm>
          <DialogRow>
            <NumberInput
              onBlur={e => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                updateFrom(e.target.rawValue);
              }}
              onChange={changeFrom}
              value={from}
              label={t("classification.minSize", { ns: "dialogs" })}
              counter
              width={"7.625rem"}
              min={SYMBOL_LIMITS.MIN_CLUSTER_SIZE}
              max={SYMBOL_LIMITS.MAX_CLUSTER_SIZE}
              zIndex={110}
              units={Units.Pixels}
              disabled={checked}
            />
            <Dash>-</Dash>
            <NumberInput
              onBlur={e => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                updateTo(e.target.rawValue);
              }}
              onChange={changeTo}
              value={to}
              label={t("classification.maxSize", { ns: "dialogs" })}
              counter
              width={"7.625rem"}
              min={SYMBOL_LIMITS.MIN_CLUSTER_SIZE}
              max={SYMBOL_LIMITS.MAX_CLUSTER_SIZE}
              zIndex={110}
              units={Units.Pixels}
            />
          </DialogRow>
          <DialogRow>
            <Checkbox
              label={t("clusterSizeRanges.useSingleObjectSize", { ns: "dialogs" })}
              checked={checked}
              onChange={toggleSingleObjectSize}
            />
          </DialogRow>
        </DialogForm>
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton onClick={recalc} primary>
            {t("actions.apply", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={resetDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </ModalDialog>
  );
};
